import styled, { createGlobalStyle } from 'styled-components';

export const PopupContentStyled = createGlobalStyle`
   .sc-dSIIpw { flex: 1 1 0; min-width: 0; }
`;